import { getBaseUrl } from './url'

export const getWindowLocationOrigin = () => getBaseUrl()
